export default {
  zh: {
    title: '合并潜在客户',
    master: '首要记录',
    aboutMaster: '请选择一个首要记录，所有系统生成的值在合并时将以首要记录对应的字段为准',
  },
  en: {     
    title: 'Merge Leads',
    master: 'Master Record',
    aboutMaster: 'Please select a Master record. All system-generated fields will use the corresponding field value from the Master record when merge.',
  },
};



// WEBPACK FOOTER //
// ./src/views/MergeLeads/i18n.js